export default {
  labels: {
    radius: 'Rayon',
  },
};
